import { createLogic } from "redux-logic";
import {
    getSessionStorageParams,
    removeCarDeliveryFromStorage,
    setCarDeliveryToStorage,
} from "../../utils/sessionStorage";
import { type UscCarDeliverySetConfig, USC_CAR_DELIVERY_SET_CONFIG } from "../actions/UscCarDeliveryActions";
import { calculateExternalPrice } from "../actions/UscExternalPriceActions";
import type { UscLogicType } from "../store";

const carDeliverySetConfigLogic = (createLogic as UscLogicType<UscCarDeliverySetConfig>)({
    type: USC_CAR_DELIVERY_SET_CONFIG,

    process({ getState }, dispatch, done) {
        const currentState = getState();
        const { carDelivery, dealer } = currentState;

        const sessionStorageParams = getSessionStorageParams(currentState);
        if (carDelivery.deliveryConfig && dealer.dealer) {
            setCarDeliveryToStorage(sessionStorageParams, carDelivery.deliveryConfig, dealer.dealer?.id);
        }

        // If we dispatch null, it means we want to clear the car delivery config.
        // This should also clear the car delivery config from the session storage.
        if (carDelivery.deliveryConfig === null) {
            removeCarDeliveryFromStorage(sessionStorageParams);
        }

        // Any time the set car delivery config action is dispatched, we should calculate the external price.
        dispatch(calculateExternalPrice());

        done();
    },
});

export default [carDeliverySetConfigLogic];
